export default __webpack_public_path__ + "static/media/DB_4.a798dd80.png";